import { IpaginatedSeccionturismos, ISeccionturismosItem } from '../models'

export enum SeccionturismosActionTypes {
  SEARCH_SECCIONTURISMOS = 'seccionturismos/search',
  SEARCHING_SECCIONTURISMOS = 'seccionturismos/searching',
  FOUND_SECCIONTURISMOS = 'seccionturismos/found',
  SEARCHING_SECCIONTURISMOS_FAILED = 'seccionturismos/searching_failed',

  LOAD_SECCIONTURISMOS = 'seccionturismos/load',
  LOADING_SECCIONTURISMOS = 'seccionturismos/loading',
  LOADED_SECCIONTURISMOS = 'seccionturismos/loaded',
  LOADING_SECCIONTURISMOS_FAILED = 'seccionturismos/loading_failed',

  ADD_SECCIONTURISMOS = 'seccionturismos/add',
  ADDING_SECCIONTURISMOS = 'seccionturismos/adding',
  ADDED_SECCIONTURISMOS = 'seccionturismos/added',
  ADDING_SECCIONTURISMOS_FAILED = 'seccionturismos/adding_failed',

  REMOVE_SECCIONTURISMO = 'seccionturismos/remove',
  REMOVING_SECCIONTURISMO = 'seccionturismos/removing',
  REMOVED_SECCIONTURISMO = 'seccionturismos/removed',
  REMOVING_SECCIONTURISMO_FAILED = 'seccionturismos/removing_failed',

  SOFT_REMOVE_SECCIONTURISMOS = 'seccionturismos/soft_remove',
  SOFT_REMOVING_SECCIONTURISMOS = 'seccionturismos/soft_removing',
  SOFT_REMOVED_SECCIONTURISMOS = 'seccionturismos/soft_removed',
  SOFT_REMOVING_SECCIONTURISMOS_FAILED = 'seccionturismos/soft_removing_failed',

  EDIT_SECCIONTURISMOS = 'seccionturismos/edit',
  EDITING_SECCIONTURISMOS = 'seccionturismos/editing',
  EDITED_SECCIONTURISMOS = 'seccionturismos/edited',
  EDITING_SECCIONTURISMOS_FAILED = 'seccionturismos/editing_failed',

  VIEW_SECCIONTURISMOS = 'seccionturismos/view',
  VIEWING_SECCIONTURISMOS = 'seccionturismos/viewing',
  VIEWED_SECCIONTURISMOS = 'seccionturismos/viewed',
  VIEWING_SECCIONTURISMOS_FAILED = 'seccionturismos/viewing_failed',
}

export function searchSeccionturismos(searchOptions: TSearchOptions | string, keep?: boolean): ISearchSeccionturismosAction {
  return {
    type: SeccionturismosActionTypes.SEARCH_SECCIONTURISMOS,
    searchOptions: typeof searchOptions === 'string' ? { searchString: searchOptions } : searchOptions,
    keep: keep,
  }
}

export function searchingSeccionturismos(): ISearchingSeccionturismosAction {
  return {
    type: SeccionturismosActionTypes.SEARCHING_SECCIONTURISMOS,
  }
}

export function foundSeccionturismos(seccionturismos: IpaginatedSeccionturismos, keep?: boolean): IFoundSeccionturismosAction {
  return {
    type: SeccionturismosActionTypes.FOUND_SECCIONTURISMOS,
    keep: keep,
    payload: {
      seccionturismos,
    },
  }
}

export function searchingSeccionturismosFailed(): ISearchingSeccionturismosFailedAction {
  return {
    type: SeccionturismosActionTypes.SEARCHING_SECCIONTURISMOS_FAILED,
  }
}

export function loadSeccionturismos(loadOptions: TSearchOptions): ILoadSeccionturismosAction {
  return {
    type: SeccionturismosActionTypes.LOAD_SECCIONTURISMOS,
    loadOptions: loadOptions,
  }
}

export function loadingSeccionturismos(): ILoadingSeccionturismosAction {
  return {
    type: SeccionturismosActionTypes.LOADING_SECCIONTURISMOS,
  }
}

export function loadedSeccionturismos(seccionturismos: IpaginatedSeccionturismos): ILoadedSeccionturismosAction {
  return {
    type: SeccionturismosActionTypes.LOADED_SECCIONTURISMOS,
    payload: {
      seccionturismos,
    },
  }
}

export function loadingSeccionturismosFailed(): ILoadingSeccionturismosFailedAction {
  return {
    type: SeccionturismosActionTypes.LOADING_SECCIONTURISMOS_FAILED,
  }
}

export function addSeccionturismos(seccionturismo: ISeccionturismosItem): IAddSeccionturismosAction {
  return {
    type: SeccionturismosActionTypes.ADD_SECCIONTURISMOS,
    payload: seccionturismo,
  }
}

export function addingSeccionturismos(): IAddingSeccionturismosAction {
  return {
    type: SeccionturismosActionTypes.ADDING_SECCIONTURISMOS,
  }
}

export function addedSeccionturismos(seccionturismos: IpaginatedSeccionturismos): IAddedSeccionturismosAction {
  return {
    type: SeccionturismosActionTypes.ADDED_SECCIONTURISMOS,
    payload: {
      seccionturismos,
    },
  }
}

export function addingSeccionturismosFailed(errData: {
  data: { message: string; field?: string }
  status: number
}): IAddingSeccionturismosFailedAction {
  return {
    type: SeccionturismosActionTypes.ADDING_SECCIONTURISMOS_FAILED,
    message: errData.data.message,
    status: errData.status,
    field: errData.data.field,
  }
}

export function removeSeccionturismo(seccionturismo: ISeccionturismosItem): IRemoveSeccionturismoAction {
  return {
    type: SeccionturismosActionTypes.REMOVE_SECCIONTURISMO,
    payload: seccionturismo,
  }
}

export function removingSeccionturismo(): IRemovingSeccionturismoAction {
  return {
    type: SeccionturismosActionTypes.REMOVING_SECCIONTURISMO,
  }
}

export function removedSeccionturismo(): IRemovedSeccionturismoAction {
  return {
    type: SeccionturismosActionTypes.REMOVED_SECCIONTURISMO,
  }
}

export function removingSeccionturismoFailed(): IRemovingSeccionturismoFailedAction {
  return {
    type: SeccionturismosActionTypes.REMOVING_SECCIONTURISMO_FAILED,
  }
}

export function softRemoveSeccionturismos(seccionturismo: ISeccionturismosItem): ISoftRemoveSeccionturismosAction {
  return {
    type: SeccionturismosActionTypes.SOFT_REMOVE_SECCIONTURISMOS,
    payload: seccionturismo,
  }
}

export function softRemovingSeccionturismos(): ISoftRemovingSeccionturismosAction {
  return {
    type: SeccionturismosActionTypes.SOFT_REMOVING_SECCIONTURISMOS,
  }
}

export function softRemovedSeccionturismos(seccionturismo: ISeccionturismosItem): ISoftRemovedSeccionturismosAction {
  return {
    type: SeccionturismosActionTypes.SOFT_REMOVED_SECCIONTURISMOS,
    payload: seccionturismo,
  }
}

export function softRemovingSeccionturismosFailed(errData: {
  data: { message: string; field?: string }
  status: number
}): ISoftRemovingSeccionturismosFailedAction {
  return {
    type: SeccionturismosActionTypes.SOFT_REMOVING_SECCIONTURISMOS_FAILED,
    message: errData.data.message,
    status: errData.status,
    field: errData.data.field,
  }
}

export function editSeccionturismos(seccionturismo: ISeccionturismosItem): IEditSeccionturismosAction {
  return {
    type: SeccionturismosActionTypes.EDIT_SECCIONTURISMOS,
    payload: seccionturismo,
  }
}

export function editingSeccionturismos(): IEditingSeccionturismosAction {
  return {
    type: SeccionturismosActionTypes.EDITING_SECCIONTURISMOS,
  }
}

export function editedSeccionturismos(seccionturismos: ISeccionturismosItem): IEditedSeccionturismosAction {
  return {
    type: SeccionturismosActionTypes.EDITED_SECCIONTURISMOS,
    payload: seccionturismos,
  }
}

export function editingSeccionturismosFailed(errData: {
  data: { message: string; field?: string }
  status: number
}): IEditingSeccionturismosFailedAction {
  return {
    type: SeccionturismosActionTypes.EDITING_SECCIONTURISMOS_FAILED,
    message: errData.data.message,
    status: errData.status,
    field: errData.data.field,
  }
}

export function viewSeccionturismos(seccionturismo: ISeccionturismosItem): IViewSeccionturismosAction {
  return {
    type: SeccionturismosActionTypes.VIEW_SECCIONTURISMOS,
    payload: seccionturismo,
  }
}

export function viewingSeccionturismos(): IViewingSeccionturismosAction {
  return {
    type: SeccionturismosActionTypes.VIEWING_SECCIONTURISMOS,
  }
}

export function viewedSeccionturismos(seccionturismos: ISeccionturismosItem): IViewedSeccionturismosAction {
  return {
    type: SeccionturismosActionTypes.VIEWED_SECCIONTURISMOS,
    payload: seccionturismos,
  }
}

export function viewingSeccionturismosFailed(): IViewingSeccionturismosFailedAction {
  return {
    type: SeccionturismosActionTypes.VIEWING_SECCIONTURISMOS_FAILED,
  }
}

type TSearchOptions = {
  searchString?: string
  searchField?: string
  page?: number
  limit?: number
  populate?: boolean
  sort?: {
    field: string
    method?: 'asc' | 'desc'
  }
  filters?: { field: string; value: string }[]
}

export interface ISearchSeccionturismosAction {
  type: SeccionturismosActionTypes.SEARCH_SECCIONTURISMOS
  searchOptions: TSearchOptions
  keep?: boolean
}

export interface ISearchingSeccionturismosAction {
  type: SeccionturismosActionTypes.SEARCHING_SECCIONTURISMOS
}

export interface IFoundSeccionturismosAction {
  type: SeccionturismosActionTypes.FOUND_SECCIONTURISMOS
  keep?: boolean
  payload: {
    seccionturismos: IpaginatedSeccionturismos
  }
}

export interface ISearchingSeccionturismosFailedAction {
  type: SeccionturismosActionTypes.SEARCHING_SECCIONTURISMOS_FAILED
}

export interface ILoadSeccionturismosAction {
  type: SeccionturismosActionTypes.LOAD_SECCIONTURISMOS
  loadOptions: TSearchOptions
}

export interface ILoadingSeccionturismosAction {
  type: SeccionturismosActionTypes.LOADING_SECCIONTURISMOS
}

export interface ILoadedSeccionturismosAction {
  type: SeccionturismosActionTypes.LOADED_SECCIONTURISMOS
  payload: {
    seccionturismos: IpaginatedSeccionturismos
  }
}

export interface ILoadingSeccionturismosFailedAction {
  type: SeccionturismosActionTypes.LOADING_SECCIONTURISMOS_FAILED
}

export interface IAddSeccionturismosAction {
  type: SeccionturismosActionTypes.ADD_SECCIONTURISMOS
  payload: ISeccionturismosItem
}

export interface IAddingSeccionturismosAction {
  type: SeccionturismosActionTypes.ADDING_SECCIONTURISMOS
}

export interface IAddedSeccionturismosAction {
  type: SeccionturismosActionTypes.ADDED_SECCIONTURISMOS
  payload: {
    seccionturismos: IpaginatedSeccionturismos
  }
}

export interface IAddingSeccionturismosFailedAction {
  type: SeccionturismosActionTypes.ADDING_SECCIONTURISMOS_FAILED
  message: string
  status: number
  field?: string
}

export interface IRemoveSeccionturismoAction {
  type: SeccionturismosActionTypes.REMOVE_SECCIONTURISMO
  payload: ISeccionturismosItem
}

export interface IRemovingSeccionturismoAction {
  type: SeccionturismosActionTypes.REMOVING_SECCIONTURISMO
}

export interface IRemovedSeccionturismoAction {
  type: SeccionturismosActionTypes.REMOVED_SECCIONTURISMO
}

export interface IRemovingSeccionturismoFailedAction {
  type: SeccionturismosActionTypes.REMOVING_SECCIONTURISMO_FAILED
}

export interface ISoftRemoveSeccionturismosAction {
  type: SeccionturismosActionTypes.SOFT_REMOVE_SECCIONTURISMOS
  payload: ISeccionturismosItem
}

export interface ISoftRemovingSeccionturismosAction {
  type: SeccionturismosActionTypes.SOFT_REMOVING_SECCIONTURISMOS
}

export interface ISoftRemovedSeccionturismosAction {
  type: SeccionturismosActionTypes.SOFT_REMOVED_SECCIONTURISMOS
  payload: ISeccionturismosItem
}

export interface ISoftRemovingSeccionturismosFailedAction {
  type: SeccionturismosActionTypes.SOFT_REMOVING_SECCIONTURISMOS_FAILED
  message: string
  status: number
  field?: string
}

export interface IEditSeccionturismosAction {
  type: SeccionturismosActionTypes.EDIT_SECCIONTURISMOS
  payload: ISeccionturismosItem
}

export interface IEditingSeccionturismosAction {
  type: SeccionturismosActionTypes.EDITING_SECCIONTURISMOS
}

export interface IEditedSeccionturismosAction {
  type: SeccionturismosActionTypes.EDITED_SECCIONTURISMOS
  payload: ISeccionturismosItem
}

export interface IEditingSeccionturismosFailedAction {
  type: SeccionturismosActionTypes.EDITING_SECCIONTURISMOS_FAILED
  message: string
  status: number
  field?: string
}

export interface IViewSeccionturismosAction {
  type: SeccionturismosActionTypes.VIEW_SECCIONTURISMOS
  payload: ISeccionturismosItem
}

export interface IViewingSeccionturismosAction {
  type: SeccionturismosActionTypes.VIEWING_SECCIONTURISMOS
}

export interface IViewedSeccionturismosAction {
  type: SeccionturismosActionTypes.VIEWED_SECCIONTURISMOS
  payload: ISeccionturismosItem
}

export interface IViewingSeccionturismosFailedAction {
  type: SeccionturismosActionTypes.VIEWING_SECCIONTURISMOS_FAILED
}

export type SeccionturismosAction =
  | ISearchSeccionturismosAction
  | ISearchingSeccionturismosAction
  | IFoundSeccionturismosAction
  | ISearchingSeccionturismosFailedAction
  | ILoadSeccionturismosAction
  | ILoadingSeccionturismosAction
  | ILoadedSeccionturismosAction
  | ILoadingSeccionturismosFailedAction
  | IAddSeccionturismosAction
  | IAddingSeccionturismosAction
  | IAddedSeccionturismosAction
  | IAddingSeccionturismosFailedAction
  | IRemoveSeccionturismoAction
  | IRemovingSeccionturismoAction
  | IRemovedSeccionturismoAction
  | IRemovingSeccionturismoFailedAction
  | ISoftRemoveSeccionturismosAction
  | ISoftRemovingSeccionturismosAction
  | ISoftRemovedSeccionturismosAction
  | ISoftRemovingSeccionturismosFailedAction
  | IEditSeccionturismosAction
  | IEditingSeccionturismosAction
  | IEditedSeccionturismosAction
  | IEditingSeccionturismosFailedAction
  | IViewSeccionturismosAction
  | IViewingSeccionturismosAction
  | IViewedSeccionturismosAction
  | IViewingSeccionturismosFailedAction
